import React from 'react';
import { Box, Typography } from '@mui/material';
import { fonts } from '../../constants';

/**
 * StatusCard Component
 * Individual status card within region card
 */
const StatusCard = ({ statusConfig, count, isSelected, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'relative',
        border: isSelected ? `1.5px solid ${statusConfig.color}` : '1.5px solid #e5e7eb',
        borderRadius: { xs: '8px', md: '6px', lg: '5px' },
        py: { xs: '6px', md: '5px', lg: '3px' },
        px: { xs: '4px', md: '3px', lg: '2px' },
        backgroundColor: isSelected ? statusConfig.bgColor : '#ffffff',
        textAlign: 'center',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        minHeight: { xs: '48px', md: '42px', lg: '38px' },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: '1px', md: '0px', lg: '0px' },
        boxShadow: isSelected 
          ? `0 4px 14px ${statusConfig.color}20`
          : '0 2px 4px rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
        '&:hover': {
          borderColor: statusConfig.color,
          backgroundColor: isSelected ? statusConfig.bgColor : `${statusConfig.bgColor}80`,
          transform: 'translateY(-2px)',
          boxShadow: `0 6px 18px ${statusConfig.color}25`,
        },
      }}
    >
      {/* Count */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: fonts.weightBold,
          fontSize: { xs: '1.2rem', md: '0.95rem', lg: '0.75rem' },
          color: statusConfig.color,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {count}
      </Typography>
      
      {/* Label */}
      <Typography
        variant="caption"
        sx={{
          fontSize: { xs: '0.5rem', md: '0.45rem', lg: '0.4rem' },
          color: isSelected ? statusConfig.color : '#64748b',
          fontWeight: fonts.weightSemiBold,
          textTransform: 'uppercase',
          letterSpacing: { xs: '0.02em', md: '0.015em', lg: '0.01em' },
          mt: { xs: '1px', md: '0px', lg: '0px' },
          lineHeight: 1.1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%',
          px: { xs: '2px', md: '2px', lg: '1px' },
        }}
      >
        {statusConfig.label}
      </Typography>
    </Box>
  );
};

export default StatusCard;
